/**
 * 
 */
import { DepartmentShort } from '@n3/ng-api-common';
import { Capacity } from '@n3/ng-api-common';
import { JobShort } from '@n3/ng-api-common';
import { Address } from '@n3/ng-api-common';
import { Contact } from '@n3/ng-api-common';
export class Department extends DepartmentShort {
    public _isEmpty: boolean; /*указывает на то пустой ли объект*/
    public capacity: Capacity; /**/
    public head: JobShort; /**/
    public address: Address; /**/
    public contacts: Contact[]; /*Контактная информация*/
    public is_based_on_another_organization: boolean; /*Располагается на базе другого учреждения*/
    public foundation_date: string; /*Дата создания*/
    public liquidation_date: string; /*Дата ликвидации*/

    constructor(json?: any) {
        if (json === void 0 || json === null) {
            json = {};
        }
        super(json);

        this.capacity = new Capacity(json.capacity);
        this.head = new JobShort(json.head);
        this.address = new Address(json.address);
        this.contacts = [];
        if (json.contacts) {
          for (const i in json.contacts) {
            if ( json.contacts.hasOwnProperty( i ) ) {
                this.contacts.push(new Contact(json.contacts[i]));
            }
          }
        }
        this.is_based_on_another_organization = json.is_based_on_another_organization || null;
        this.foundation_date = json.foundation_date || null;
        this.liquidation_date = json.liquidation_date || null;
        this._isEmpty = this.isEmpty(this);
    }
}
